<template>
  <div>
    <div class="row">
      <div class="col-md-12 ts-flex">
        <div class="col-md-6">
          <label>ការសិក្សា</label>
          <div>
            <input
              v-model="model.academic_performance"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-6">
          <label>សីលធម៌រស់នៅ</label>
          <div>
            <input
              v-model="model.moral_behavior"
              type="text"
              class="form-control"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 ts-flex">
        <div class="col-md-6">
          <label>ពលកម្ម-បង្កបង្កើនផល</label>
          <div>
            <input
              v-model="model.productivity"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-md-6">
          <label>សុខភាព-អនាម័យ</label>
          <div>
            <input v-model="model.hygiene" type="text" class="form-control" />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 text-right">
        <ts-button @click.prevent="$emit('closeModal')">
          {{ $t('cancel') }}
        </ts-button>

        <ts-button
          v-if="model.id == 0"
          class="ml-2"
          color="primary"
          @click.prevent="ratingScaleSave"
          :waiting="save_rating_scale"
        >
          {{ $t('save') }}
        </ts-button>
        <ts-button
          v-if="model.id != 0"
          color="primary"
          :waiting="waiting"
          @click.prevent="onUpdate"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'rating-scale',
  props: ['value'],
  data() {
    return {
      model: {
        academic_performance: null,
        moral_behavior: null,
        personal_hygiene: null,
        productivity: null,
        hygiene: null,
        student_id: null,
        id: 0
      },
      errors: new Errors(),
      save_rating_scale: false,
      waiting: false
    }
  },
  created() {
    this.model.student_id = this.value.student_id
    this.model.scoring_cycle_id = this.value.scoring_cycle_id
    this.model.cycle_value = this.value.cycle_value
    this.fetchRatingScal()
  },
  methods: {
    ratingScaleSave() {
      this.errors = new Errors()
      this.save_rating_scale = true
      this.$store
        .dispatch('studentScoringEntry/saveRatingScale', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.save_rating_scale = false
          this.clearForm()
          this.$emit('closeModal')
        })
        .catch(error => {
          this.save_rating_scale = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    fetchRatingScal() {
      this.loading = true
      this.$store
        .dispatch('studentScoringEntry/findRatingScal', {
          params: {
            student_id: this.value.student_id,
            scoring_cycle_id: this.value.scoring_cycle_id,
            cycle_value: this.value.cycle_value,
            id: this.value.id
          }
        })
        .then(response => {
          if (response.data) {
            this.model.academic_performance = response.data.academic_performance
            this.model.moral_behavior = response.data.moral_behavior
            this.model.productivity = response.data.productivity
            this.model.hygiene = response.data.hygiene
            this.model.id = response.data.id
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('studentScoringEntry/updateRatingScale', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearForm()
          this.$emit('closeModal')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearForm() {
      this.model = {
        academic_performance: null,
        moral_behavior: null,
        productivity: null,
        hygiene: null,
        student_id: null,
        scoring_cycle_id: null,
        cycle_value: null,
      }
    }
  }
}
</script>
